import { createSelector } from 'reselect';

const substate = (state) => state.policy;

export const selectRiskChanged = () => createSelector(substate, (contextState) => contextState.riskChanged);
